import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://qashqconsultants.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;

function SEO({
  title = 'QASHQ Business & IT Consultants',
  description = 'Business and IT consulting solutions designed to help businesses operate smarter, grow faster, and build for the future. Accounting, advisory, and technology services under one roof.',
  path = '/',
  type = 'website',
  image = DEFAULT_OG_IMAGE,
  noindex = false,
}) {
  const fullTitle = title.includes('QASHQ') ? title : `${title} | QASHQ Business & IT Consultants`;
  const canonicalUrl = `${SITE_URL}${path}`;

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'QASHQ Business & IT Consultants',
    url: SITE_URL,
    logo: `${SITE_URL}/android-chrome-512x512.png`,
    description,
    email: 'contact.qashq@gmail.com',
    telephone: '+92-347-9310319',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Rawalpindi',
      addressRegion: 'Punjab',
      addressCountry: 'PK',
    },
    sameAs: [
      'https://www.linkedin.com/company/104664276',
      'https://www.facebook.com/profile.php?id=61565421696183',
      'https://x.com/qashqBITC',
      'https://www.youtube.com/channel/UCDLU344Bey3y74nw14jC4fw',
    ],
    areaServed: 'Worldwide',
    serviceType: ['Business Consulting', 'Accounting', 'IT Consulting', 'Software Development'],
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="QASHQ Business & IT Consultants" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    </Helmet>
  );
}

export default SEO;
